import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export type ChartPeriod = '7d' | '30d' | '90d';

/** Quantos dias somar por ponto do gráfico, pra não poluir em períodos longos. */
export function daysPerGroup(period: ChartPeriod): number {
  if (period === '7d') return 1;
  if (period === '30d') return 2;
  return 7;
}

/**
 * Agrupa uma série diária em baldes somados, mantendo a data do primeiro dia
 * de cada balde. Genérico: recebe os campos numéricos a somar.
 */
export function groupByPeriod<T extends { date: string }>(
  data: T[],
  period: ChartPeriod,
  numericKeys: (keyof T)[],
): T[] {
  const step = daysPerGroup(period);
  const out: T[] = [];
  for (let i = 0; i < data.length; i += step) {
    const bucket = data.slice(i, i + step);
    const merged = { ...bucket[0] };
    for (const key of numericKeys) {
      merged[key] = bucket.reduce(
        (sum, d) => sum + (d[key] as number),
        0,
      ) as T[keyof T];
    }
    out.push(merged);
  }
  return out;
}

/**
 * Decide quais índices mostram label no eixo X: sempre o primeiro e o último,
 * mais alguns intermediários espaçados quando há muitos pontos.
 */
export function buildXLabels(dates: string[]): string[] {
  const n = dates.length;
  return dates.map((date, index) => {
    const show =
      index === 0 ||
      index === n - 1 ||
      (n > 5 && index % Math.ceil(n / 4) === 0);
    return show ? format(new Date(date), 'dd/MM', { locale: ptBR }) : '';
  });
}

/** R$ compacto pro eixo Y: 1.2k acima de mil, inteiro abaixo. */
export function formatCurrencyAxis(value: number): string {
  if (Math.abs(value) >= 1000) return `R$ ${(value / 1000).toFixed(1)}k`;
  return `R$ ${value.toFixed(0)}`;
}

/** Número inteiro pro eixo Y. */
export function formatNumberAxis(value: number): string {
  return value.toFixed(0);
}
